export const MONETARY_SUPPORT_OPTION_DEFS = [
  {
    id: "tikkie",
    envKey: "REACT_APP_SUPPORT_URL",
    labelKey: "web.supportModal.options.tikkie.label",
    hintKey: "web.supportModal.options.tikkie.hint",
  },
  {
    id: "mollie",
    envKey: "REACT_APP_SUPPORT_MOLLIE_URL",
    labelKey: "web.supportModal.options.mollie.label",
    hintKey: "web.supportModal.options.mollie.hint",
  },
  {
    id: "github",
    envKey: "REACT_APP_SUPPORT_GITHUB_URL",
    labelKey: "web.supportModal.options.github.label",
    hintKey: "web.supportModal.options.github.hint",
  },
];

/** @deprecated Use MONETARY_SUPPORT_OPTION_DEFS */
export const MONETARY_SUPPORT_OPTIONS = MONETARY_SUPPORT_OPTION_DEFS;

export function getSupportLinks({
  options = MONETARY_SUPPORT_OPTION_DEFS,
  env = process.env,
  display,
} = {}) {
  return options
    .map(({ envKey, labelKey, hintKey, ...rest }) => ({
      ...rest,
      label: display?.t(labelKey) ?? labelKey,
      hint: display?.t(hintKey) ?? hintKey,
      url: env[envKey]?.trim() || "",
    }))
    .filter((option) => option.url);
}

export function getSupportUrl(options) {
  return getSupportLinks(options)[0]?.url || "";
}

export function shouldShowSupport() {
  return true;
}
